module.exports = __webpack_public_path__ + "assets/img/mp3.c5a0b9c4.png";